module.exports = __webpack_public_path__ + "static/media/Pedidos6.fe7dfff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancPedidos/Pedidos6.png
// module id = 1784
// module chunks = 0